import { Button, ButtonProps } from '@chakra-ui/react';
import { Icons, defaultIconSize } from './Icons';

interface Props extends ButtonProps {
  isOpen: boolean;
  onToggle: () => void;
  label: string;
}

export function CollapseButton({
  isOpen,
  onToggle,
  label,
  ...buttonProps
}: Props) {
  return (
    <Button
      {...buttonProps}
      justifyContent="space-between"
      onClick={onToggle}
      rightIcon={
        isOpen ? (
          <Icons.ChevronUp boxSize={defaultIconSize} />
        ) : (
          <Icons.ChevronDown boxSize={defaultIconSize} />
        )
      }
    >
      {label}
    </Button>
  );
}
